import React from 'react'
import "./contact.css"
import emailjs from 'emailjs-com'


function Contact() {

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('gmail', 'template_nui3ax8', e.target, "user_V9EZJhLDONWs6GD3PrwKs")
            .then((result) => {
                console.log(result.text);
            }, (error) => {
                console.log(error.text);
            });
        e.target.reset()
    }



    return (
        <>



           

             <section class="section gray-bg" id="contactus">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="section-title">
                                <h2>Get In Touch</h2>
                                <p>"Taking pictures is savoring life intensely, every hundredth of a second.”</p>
                            </div>
                        </div>
                    </div>
                    <div class="row flex-row-reverse">
                        <div class="col-md-7 col-lg-8 m-15px-tb">
                            <div class="contact-form">
                                <form onSubmit={sendEmail} class="contactform contact_form" id="contact_form">
                                    <div class="returnmessage valid-feedback p-15px-b" data-success="Your message has been received, We will contact you soon."></div>
                                    <div class="empty_notice invalid-feedback p-15px-b"><span>Please Fill Required Fields</span></div>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <input id="name" name="from_name" type="text" placeholder="Full Name" class="form-control"  />
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <input id="email" name="email" type="text" placeholder="Email Address" class="form-control"  />
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <div class="form-group">
                                                <input id="subject" name="subject" type="text" placeholder="Subject" class="form-control" />
                                            </div>
                                        </div>

                                        <div class="col-12">
                                            <div class="form-group">
                                                <input id="subject" name="eventdate" type="number" placeholder="Date of Event"  class="form-control" />
                                            </div>
                                        </div>


                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <textarea id="message" name="message" placeholder="Message" class="form-control" rows="3"></textarea>
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="send">
                                                <a id="send_message" name="submit" class="px-btn theme" type="submit"><span>Contact Us</span> <i class="arrow"></i></a>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div class="col-md-5 col-lg-4 m-15px-tb">
                            <div class="contact-name">
                                <h5>Mail</h5>
                                <p>info@teamaesthete.com</p>
                            </div>
                            <div class="contact-name">
                                <h5>Our Location</h5>
                                <p>Warnwe Park Streetperrine, FL 33157 New York City</p>
                            </div>
                            <div class="contact-name">
                                <h5>Phone</h5>
                                <p>+92-314-2086253</p>
                                <p>+92-312-2947465</p>

                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Contact
